<template>
  <prism-editor
    id="code-editor" class="my-editor" v-model="displayValue"
    :highlight="highlighter"
    line-numbers
  >
  </prism-editor>
</template>

<script>
import { PrismEditor } from 'vue-prism-editor';
import 'vue-prism-editor/dist/prismeditor.min.css'; // import the styles somewhere
import { highlight, languages } from 'prismjs/components/prism-core';
import 'prismjs/components/prism-clike';
import 'prismjs/components/prism-javascript';
import 'prismjs/themes/prism-tomorrow.css'; // import syntax highlighting styles

export default {
  name: 'CodeEditor',
  components: {
    PrismEditor,
  },
  props: {
    value: { type: String, required: false },
  },
  computed: {
    displayValue: {
      get() {
        return this.value;
      },
      set(modifiedValue) {
        this.$emit('input', modifiedValue);
      }
    }
  },
  methods: {
    highlighter(code) {
      // languages.<insert language> to return html with markup
      return highlight(code, languages.js, languages.html);
    },
    input() {
      this.$emit('input', this.valueMutable);
    },
    toggle() {
      this.isPreview = !this.isPreview;
      if (this.isPreview) {
        this.htmlData = this.proccessString(
          this.$el.querySelector('.visual-preview').outerHTML
        );
      }
    },
    proccessString(string) {
      const div = document.createElement('div');
      div.innerHTML = string.trim();
      return this.formatString(div, 0).innerHTML;
    },
    formatString(node, level) {
      // eslint-disable-next-line no-param-reassign,no-plusplus
      const indentBefore = new Array(level++ + 1).join('  ');
      const indentAfter = new Array(level - 1).join('  ');
      let textNode;

      for (let i = 0; i < node.children.length; i += 1) {
        textNode = document.createTextNode(`\n${indentBefore}`);
        this.removeVueAttributes(node.children[i]);
        node.insertBefore(textNode, node.children[i]);

        this.formatString(node.children[i], level);

        if (node.lastElementChild === node.children[i]) {
          textNode = document.createTextNode(`\n${indentAfter}`);
          node.appendChild(textNode);
        }
      }
      return node;
    },

    removeVueAttributes(node) {
      const { attributes } = node;
      if (attributes) {
        let keys = Object.keys(attributes);
        for (let i = 0; i < keys.length; i += 1) {
          const attr = keys[i];
          if (attributes[attr].localName.includes('data-v')) {
            node.attributes.removeNamedItem(attributes[attr].localName);
            keys = Object.keys(attributes);
            i -= 1;
          }
        }
      }

      if (node.children) {
        for (let i = 0; i < node.children.length; i += 1) {
          this.removeVueAttributes(node.children[i]);
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/prism-editor.scss";
</style>
